import React from 'react';
import { Spacer, Text } from '@badi/badi-components';
import { Legend, CalendarLegendWrapper, LegendMarker } from './styled-components';
import { translate } from 'base/shared/Localization';

const CalendarLegend = ({ isMoveIn }) => {
  const firstDay = isMoveIn ? '1st' : '14th';
  const lastDay = isMoveIn ? '15th' : 'last day';
  const action = isMoveIn ? 'check-in' : 'check-out';

  return (
    <CalendarLegendWrapper>
      <Spacer bottom={2}>
        <Text body="14-Medium">{translate('booking.biweekly.title')}</Text>
        <Text body="14-Medium">
          {translate('booking.biweekly.info', {
            firstDay: firstDay,
            lastDay: lastDay,
            action: action,
          })}
        </Text>
      </Spacer>
      <Legend>
        <LegendMarker /> {translate('booking.biweekly.legend', { action: action })}
      </Legend>
    </CalendarLegendWrapper>
  );
};

export default CalendarLegend;
